// src/hooks/banks/useForceDeleteBank.js
import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { forceDeleteBank } from "../../api/apiBanks";
import { useTranslation } from "react-i18next";

function useForceDeleteBank() {
    const queryClient = useQueryClient();
    const { i18n } = useTranslation();
    const lng = i18n.language || "en";
    const isArabic = lng === "ar";

    const { mutate: forceDeleteBankMutation, isPending: isForceDelete } = useMutation({
        mutationFn: forceDeleteBank,
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ["banks"] });
            toast.success(isArabic ? "تم حذف البنك نهائياً" : "Bank permanently deleted");
        },
        onError: (err) => {
            toast.error(err?.message || (isArabic ? "فشل في الحذف النهائي" : "Failed to force delete bank"));
        },
    });

    return { forceDeleteBank: forceDeleteBankMutation, isForceDelete };
}

export default useForceDeleteBank;
